import { proxy } from "valtio";

export type ModeOfSale = { designation: string; state: boolean };

export type SalesModes = Partial<{
    customerTicketSalesModes: ModeOfSale[];
    customerInformationCompany: ModeOfSale[];
    customerInformationCity: ModeOfSale[];
    customerInformationName: ModeOfSale[];
    customerInformationNumTel: ModeOfSale[];
    customerInformationAddress: ModeOfSale[];
    customerInformationCode: ModeOfSale[];
    salesCustomerAddressModeSale: ModeOfSale[];
    customerTicket: ModeOfSale[];
    kitchenTicket: ModeOfSale[];
}>;

export type FormData = Record<string, unknown>;

type StoreType = {
    dataGeneral: FormData;
    dataDivers: FormData;
    dataKitchenTicket: FormData;
    dataCustomerTicket: FormData;
    dataFirstTicket: FormData;
    dataSecondTicket: FormData;
    dataThreedTicket: FormData;
    dataFourthTicket: FormData;
    dataFifthTicket: FormData;
    isValidated: boolean;
    checkboxIcon: boolean;
    checkboxIconSecondModel: boolean;
    checkboxIconThreedModel:boolean;
    checkboxIconFourthModel: boolean;
    checkboxIconFifthModel: boolean;
    salesModes: SalesModes;
};

export const store = proxy<StoreType>({
    dataGeneral: {},
    dataDivers: {},
    dataKitchenTicket: {},
    dataCustomerTicket: {},
    dataFirstTicket: {},
    dataSecondTicket: {},
    dataThreedTicket: {},
    dataFourthTicket: {},
    dataFifthTicket: {},
    isValidated: false,
    checkboxIcon:false,
    checkboxIconSecondModel: false,
    checkboxIconThreedModel:false,
    checkboxIconFourthModel:false,
    checkboxIconFifthModel:false,
    salesModes: {},
});

export function setSalesModes(salesModes: SalesModes): void {
    store.salesModes = salesModes;
}

export function setDataGeneral(dataGeneral: FormData): void {
    store.dataGeneral = dataGeneral;
}
export function setDivers(dataDivers: FormData): void {
    store.dataDivers = dataDivers;
}
export function setDataKitchenTicket(dataKitchenTicket: FormData): void {
    store.dataKitchenTicket = dataKitchenTicket;
}
export function setDataCustomerTicket(dataCustomerTicket: FormData): void {
    store.dataCustomerTicket = dataCustomerTicket;
}

export function setDataFirstTicket(dataFirstTicket: FormData): void {
    store.dataFirstTicket = dataFirstTicket;
}
export function setDataSecondTicket(dataSecondTicket: FormData): void {
    store.dataSecondTicket = dataSecondTicket;
}
export function setDatathreedTicket(dataThreedTicket: FormData): void {
    store.dataThreedTicket = dataThreedTicket;
}
export function setDataFourthTicket(dataFourthTicket: FormData): void {
    store.dataFourthTicket = dataFourthTicket;
}
export function setDataFifthTicket(dataFifthTicket: FormData): void {
    store.dataFifthTicket = dataFifthTicket;
}
export function setIsValidateClicked(isValidated: boolean): void {
    store.isValidated = isValidated;
}
export function setCheckboxIcon(checkboxIcon: boolean): void {
    store.checkboxIcon = checkboxIcon;
   
}

export function setCheckboxIconSecondModel(checkboxIconSecondModel: boolean): void {
    store.checkboxIconSecondModel = checkboxIconSecondModel;
    
}
export function setCheckboxIconThreedModel(checkboxIconThreedModel: boolean): void {
    store.checkboxIconThreedModel = checkboxIconThreedModel;
}
export function setCheckboxIconFourthModel(checkboxIconFourthModel: boolean): void {
    store.checkboxIconFourthModel = checkboxIconFourthModel;
}
export function setCheckboxIconFifthModel(checkboxIconFifthModel: boolean): void {
    store.checkboxIconFifthModel = checkboxIconFifthModel;
}
